import React, {useState} from "react";
import {TextField, InputAdornment, IconButton} from "@mui/material";
import {Add, Remove} from "@mui/icons-material";
import {connect} from "react-redux";
import {handleUpdateOrderSubscription} from "../../actions/ordersubscription";

export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
    handleUpdateOrderSubscription,
  }
)((props, {}) => {
  let i18n = props.i18n;
  const {userNumber} = props.orderSubscription;
  const [value, setValue] = useState(userNumber);

  const handleIncrement = () => {
    setValue((prevValue) => prevValue + 1);
    props.handleUpdateOrderSubscription({userNumber: value + 1}); // to use redux dispatch here
  };

  const handleDecrement = () => {
    setValue((prevValue) => Math.max(prevValue - 1, 0)); // Ensures value doesn't go below 0
    props.handleUpdateOrderSubscription({userNumber: Math.max(value - 1, 0)}); // to use redux dispatch here
  };

  const handleChange = (event) => {
    const newValue = parseInt(event.target.value, 10);
    setValue(isNaN(newValue) ? 0 : newValue);
  };

  return (
    <TextField
      type="number"
      value={value}
      onChange={handleChange}
      variant="outlined"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleDecrement} edge="end" size="small">
              <Remove />
            </IconButton>
            <IconButton onClick={handleIncrement} edge="end" size="small">
              <Add />
            </IconButton>
          </InputAdornment>
        ),
        inputProps: {
          style: {textAlign: "left", paddingRight: 0}, // Align text to the left
        },
      }}
      fullWidth // Optional: Makes the input field take full width of its container
    />
  );
});
